<template>
  <div class="pbr-analysis-content">
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.positiveAndNegativeSidesOfInformation.informationPositiveAndNegativeComparisonDiagram') }}</span>
          <div class="pbr-analysis-echart-div" id="information-pn"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.positiveAndNegativeSidesOfInformation.proportionOfSensitiveInformation') }}</span>
          <div class="pbr-analysis-echart-div" id="sensitive-percent"></div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.positiveAndNegativeSidesOfInformation.positiveInformationTrendChart') }}</span>
          <div class="pbr-analysis-echart-div" id="positive-trend"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.positiveAndNegativeSidesOfInformation.distributionOfPositiveInformationSources') }}</span>
          <div class="pbr-analysis-echart-div" id="positive-distribution"></div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.positiveAndNegativeSidesOfInformation.sensitiveInformationTrendChart') }}</span>
          <div class="pbr-analysis-echart-div" id="sensitive-trend"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.positiveAndNegativeSidesOfInformation.distributionOfSensitiveInformationSources') }}</span>
          <div class="pbr-analysis-echart-div" id="sensitive-distribution"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    import * as echarts from 'echarts';
    import {chartBarOption, pieChartOption, xLabelColor, chartLineOption, numberConversion} from "./constant";
    import ResizeObserver from 'resize-observer-polyfill'

    let informationPNChart;
    let sensitivePercentChart;
    let positiveTrendChart;
    let positiveDistributionChart;
    let sensitiveTrendChart;
    let sensitiveDistributionChart;

    export default {
        name: "InformationPositiveNegativeAnalysis", // 信息正负面
        props: ['condition', 'exportSuccess'],
        components: {
        },
        data() {
            return {
                sensitivePercentData: [],
                sensitiveDistributionData: [],
                queryParams: {},
                isResize: false,
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
              this.isResize = true;
            })
            this.queryParams = this.condition;
            this.initEcharts();
            this.echartTheme();
            this.search();
        },
        methods: {
            getTheme() {
                return this.$store.state.brpaModule.theme || 'white';
            },
            initEcharts() {
                let countContrastDom = document.getElementById('information-pn')

                informationPNChart = echarts.init(countContrastDom);
                informationPNChart.setOption(chartBarOption);
                sensitivePercentChart = echarts.init(document.getElementById("sensitive-percent"));
                sensitivePercentChart.setOption(chartBarOption);
                positiveTrendChart = echarts.init(document.getElementById("positive-trend"));
                positiveTrendChart.setOption(chartLineOption);
                positiveDistributionChart = echarts.init(document.getElementById("positive-distribution"));
                positiveDistributionChart.setOption(pieChartOption);
                sensitiveTrendChart = echarts.init(document.getElementById("sensitive-trend"));
                sensitiveTrendChart.setOption(chartLineOption);
                sensitiveDistributionChart = echarts.init(document.getElementById("sensitive-distribution"));
                sensitiveDistributionChart.setOption(pieChartOption);
                let that = this;
                let countContrastObserver = new ResizeObserver((entries) => {
                  if (that.isResize) {
                    that.resize();
                    if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
                      that.isResize = false;
                    }
                  }
                })
                countContrastObserver.observe(countContrastDom);
            },

            informationPNHandler(obj) {
              let that = this
                if (obj.length<=0){
                    informationPNChart.clear();
                    return ;
                }
                let series = [];
                series[0] = {name: that.$t('charts.analysis.positiveAndNegativeSidesOfInformation.positive'), data: obj.map(o=>o.positive), type: 'bar', barMaxWidth: 40, itemStyle: {
                        borderRadius: 3,
                    },};
                series[1] = {name: that.$t('charts.analysis.positiveAndNegativeSidesOfInformation.negative'), data: obj.map(o=>o.negative), type: 'bar', barMaxWidth: 40, itemStyle: {
                        borderRadius: 3,
                    },};
                const option = {
                    title: {
                      subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
                      top: 15
                    },
                    legend: {
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    yAxis: {
                        minInterval: 1,
                        boundaryGap : [ 0, 0.1 ],
                        type: 'value',
                        axisLabel:{
                            formatter: function(value) {
                                return numberConversion(value);
                            },
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    xAxis: {
                        data: obj.map(o=>o.time),
                        axisLabel: {
                            color: xLabelColor[this.getTheme()],
                        },
                    },
                    series: series
                }
                informationPNChart.clear();
                informationPNChart.setOption(chartBarOption);
                informationPNChart.setOption(option);
            },

            sensitivePercentHandler() {
              const that = this
                if (this.sensitivePercentData.length <= 0){
                    sensitivePercentChart.clear();
                    return;
                }
                let series = [];
                series[0] = {name: that.$t('charts.analysis.positiveAndNegativeSidesOfInformation.positive'), data: this.sensitivePercentData.map(o=>o.positive), type: 'bar', barMaxWidth: 40, itemStyle: {
                        borderRadius: 3,
                    },};
                series[1] = {name: that.$t('charts.analysis.positiveAndNegativeSidesOfInformation.negative'), data: this.sensitivePercentData.map(o=>o.negative), type: 'bar', barMaxWidth: 40, itemStyle: {
                        borderRadius: 3,
                    },};
                const option = {
                    title: {
                      subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
                      top: 15
                    },
                    legend: {
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    yAxis: {
                        minInterval: 1,
                        boundaryGap : [ 0, 0.1 ],
                        type: 'value',
                        axisLabel:{
                            formatter: function(value) {
                                return numberConversion(value);
                            },
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    xAxis: {
                        data: this.sensitivePercentData.map(o=>o.name),
                        show: false,
                        axisLabel: {
                            color: xLabelColor[this.getTheme()],
                            interval: 0,
                            rotate: 0,
                            formatter: function(params) {
                              let val = "";
                              let show = localStorage.getItem('locale') === 'cn' ? 4 : 10;
                              if (params.length > show) {
                                val = params.substr(0, show) + '...';
                                return val;
                              } else {
                                return params;
                              }
                            }
                        },
                    },
                    series: series
                }
                sensitivePercentChart.clear();
                sensitivePercentChart.setOption(chartBarOption);
                sensitivePercentChart.setOption(option);
            },

            positiveTrendHandler(obj) {
                  if (obj.length<=0){
                      positiveTrendChart.clear();
                      return ;
                  }
                  let series = [];
                  let ser = {};
                  ser["data"] = obj.map(o=>o.num);
                  ser["type"] = "line";
                  ser["smooth"] = true;
                  series[0] = ser;
                  const option = {
                      title: {
                        subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
                        top: 15
                      },
                      legend: {
                          textStyle: {
                              color: xLabelColor[this.getTheme()],
                          }
                      },
                      yAxis: {
                          minInterval: 1,
                          boundaryGap : [ 0, 0.1 ],
                          type: 'value',
                          axisLabel:{
                              formatter: function(value) {
                                  return numberConversion(value);
                              },
                              color: xLabelColor[this.getTheme()],
                          },
                        min: function (value) {
                          let num = 0
                          if (value.min === 0) {
                            return num
                          } else if (value.min.toString().length < 2) {
                            return value.min - 1
                          } else if (value.min.toString().length < 3) {
                            return value.min - 10
                          } else {
                            num = 10 ** (value.min.toString().length - 2)
                            return Math.floor(value.min / num) * num
                          }
                        }
                      },
                      xAxis: {
                          data: obj.map(o=>o.time),
                          axisLabel: {
                              color: xLabelColor[this.getTheme()],
                          },
                      },
                      series: series,
                  };
                  positiveTrendChart.clear();
                  positiveTrendChart.setOption(chartLineOption);
                  positiveTrendChart.setOption(option);
              },

            positiveDistributionHandler() {
                if (this.positiveDistributionData.length<=0){
                    positiveDistributionChart.clear();
                    return ;
                }
                let series = [];
                for (let i = 0; i < this.positiveDistributionData.length; i++) {
                    let ser = {};
                    ser["name"] = this.positiveDistributionData[i].name;
                    ser["value"] = this.positiveDistributionData[i].num;
                    series[i] = ser;
                }
                const option = {
                    legend: {
                        pageIconColor: xLabelColor[this.getTheme()],
                        pageTextStyle: {
                            color:xLabelColor[this.getTheme()],
                        },
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    series: [
                        {
                            type: 'pie',
                            top: '10%',
                            radius: '70%',
                            data: series,
                            label: {
                                show: true,
                                color: xLabelColor[this.getTheme()],
                                formatter: '{d}%'
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };
                  positiveDistributionChart.clear();
                  positiveDistributionChart.setOption(pieChartOption);
                  positiveDistributionChart.setOption(option);
            },

            sensitiveTrendHandler(obj) {
                if (obj.length<=0){
                    sensitiveTrendChart.clear();
                    return ;
                }
                let series = [];
                let ser = {};
                ser["data"] = obj.map(o=>o.num);
                ser["type"] = "line";
                ser["smooth"] = true;
                series[0] = ser;
                const option = {
                    title: {
                      subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
                      top: 15
                    },
                    legend: {
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    yAxis: {
                        minInterval: 1,
                        boundaryGap : [ 0, 0.1 ],
                        type: 'value',
                        axisLabel:{
                            formatter: function(value) {
                                return numberConversion(value);
                            },
                            color: xLabelColor[this.getTheme()],
                        },
                      min: function (value) {
                        let num = 0
                        if (value.min === 0) {
                          return num
                        } else if (value.min.toString().length < 2) {
                          return value.min - 1
                        } else if (value.min.toString().length < 3) {
                          return value.min - 10
                        } else {
                          num = 10 ** (value.min.toString().length - 2)
                          return Math.floor(value.min / num) * num
                        }
                      }
                    },
                    xAxis: {
                        data: obj.map(o=>o.time),
                        axisLabel: {
                            color: xLabelColor[this.getTheme()],
                        },
                    },
                    series: series,
                };
                sensitiveTrendChart.clear();
                sensitiveTrendChart.setOption(chartLineOption);
                sensitiveTrendChart.setOption(option);
            },

            sensitiveDistributionHandler() {
                if (this.sensitiveDistributionData.length<=0){
                    sensitiveDistributionChart.clear();
                    return ;
                }
                let series = [];
                for (let i = 0; i < this.sensitiveDistributionData.length; i++) {
                    let ser = {};
                    ser["name"] = this.sensitiveDistributionData[i].name;
                    ser["value"] = this.sensitiveDistributionData[i].num;
                    series[i] = ser;
                }
                const option = {
                    legend: {
                        pageIconColor: xLabelColor[this.getTheme()],
                        pageTextStyle: {
                            color:xLabelColor[this.getTheme()],
                        },
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    series: [
                        {
                            type: 'pie',
                            top: '10%',
                            radius: '70%',
                            data: series,
                            label: {
                                show: true,
                                color: xLabelColor[this.getTheme()],
                                formatter: '{d}%'
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };
                sensitiveDistributionChart.clear();
                sensitiveDistributionChart.setOption(pieChartOption);
                sensitiveDistributionChart.setOption(option);
            },

            echartTheme() {
                const option = {
                    legend: {
                        pageIconColor: xLabelColor[this.getTheme()],
                        pageTextStyle: {
                            color:xLabelColor[this.getTheme()],
                        },
                        textStyle: {
                            color:xLabelColor[this.getTheme()],
                        }
                    },
                    xAxis: {
                        axisLabel: {
                            color: xLabelColor[this.getTheme()],
                        },
                    },
                    yAxis: {
                        axisLabel: {
                            color: xLabelColor[this.getTheme()],
                        },
                    },
                };
                if(informationPNChart){
                    informationPNChart.setOption(option);
                }

                if(sensitivePercentChart){
                    const pieOption = {
                        legend: {
                            textStyle: {
                                color: xLabelColor[sessionStorage.getItem('theme')],
                            }
                        },
                    }
                    sensitivePercentChart.setOption(pieOption);
                }

                if (positiveTrendChart){
                    positiveTrendChart.setOption(option);
                }
                if (positiveDistributionChart){
                    const pieOption = {
                        legend: {
                            textStyle: {
                                color: xLabelColor[sessionStorage.getItem('theme')],
                            }
                        },
                    }
                    positiveDistributionChart.setOption(pieOption);
                }
                if (sensitiveTrendChart){
                    sensitiveTrendChart.setOption(option);
                }
                if (sensitiveDistributionChart){
                    const pieOption = {
                        legend: {
                            textStyle: {
                                color: xLabelColor[sessionStorage.getItem('theme')],
                            }
                        },
                    }
                    sensitiveDistributionChart.setOption(pieOption);
                }
            },

            /**/
            search(){
              informationPNChart.showLoading({ text: this.$t('loading'), maskColor: 'transparent',textColor: xLabelColor[sessionStorage.getItem('theme')], })
              sensitivePercentChart.showLoading({ text: this.$t('loading'), maskColor: 'transparent',textColor: xLabelColor[sessionStorage.getItem('theme')], })
              positiveTrendChart.showLoading({ text: this.$t('loading'), maskColor: 'transparent',textColor: xLabelColor[sessionStorage.getItem('theme')], })
              positiveDistributionChart.showLoading({ text: this.$t('loading'), maskColor: 'transparent',textColor: xLabelColor[sessionStorage.getItem('theme')], })
              sensitiveTrendChart.showLoading({ text: this.$t('loading'), maskColor: 'transparent',textColor: xLabelColor[sessionStorage.getItem('theme')], })
              sensitiveDistributionChart.showLoading({ text: this.$t('loading'), maskColor: 'transparent',textColor: xLabelColor[sessionStorage.getItem('theme')], })
                let param = {
                    from: 'cn',
                    module: 'xx' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
                };
                param = Object.assign(param, this.queryParams);
                this.$pbrAxios.post('/front/analyses/search',param).then((data) => {
                    let success = data.success;
                    if (success){
                        let positiveModels = data.result.positiveModels;
                        this.sensitivePercentData = data.result.nationModels;
                        let positiveLineModels = data.result.positiveLineModels;
                        this.positiveDistributionData = data.result.positiveSourceModels;
                        let lineModels = data.result.lineModels;
                        this.sensitiveDistributionData = data.result.sourceModels;

                        this.informationPNHandler(positiveModels);
                        this.sensitivePercentHandler();
                        this.positiveTrendHandler(positiveLineModels);
                        this.positiveDistributionHandler();
                        this.sensitiveTrendHandler(lineModels);
                        this.sensitiveDistributionHandler();

                    } else {

                    }
                }).finally(() => {
                    this.$emit("closeShow");
                  informationPNChart.hideLoading()
                  sensitivePercentChart.hideLoading()
                  positiveTrendChart.hideLoading()
                  positiveDistributionChart.hideLoading()
                  sensitiveTrendChart.hideLoading()
                  sensitiveDistributionChart.hideLoading()
                })
            },
            /**/
            hsearch(){
                let param = {
                    from: 'cn',
                    module: 'xx' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
                };
                param = Object.assign(param, this.queryParams);

                console.log(param);

                this.$pbrAxios.post('/front/analyses/hsearch',param).then(data => {
                    let success = data.success;
                    if (success){
                        let positiveModels = data.result.positiveModels;
                        this.sensitivePercentData = data.result.nationModels;
                        let positiveLineModels = data.result.positiveLineModels;
                        this.positiveDistributionData = data.result.positiveSourceModels;
                        let lineModels = data.result.lineModels;
                        this.sensitiveDistributionData = data.result.sourceModels;

                        this.informationPNHandler(positiveModels);
                        this.sensitivePercentHandler();
                        this.positiveTrendHandler(positiveLineModels);
                        this.positiveDistributionHandler();
                        this.sensitiveTrendHandler(lineModels);
                        this.sensitiveDistributionHandler();
                    } else {

                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.$emit("closeShow");
                });
            },

            resize() {
              if (informationPNChart!=null)
                informationPNChart.resize();
              if (sensitivePercentChart!=null)
                sensitivePercentChart.resize();
              if (positiveTrendChart!=null)
                positiveTrendChart.resize();
              if (positiveDistributionChart!=null)
                positiveDistributionChart.resize();
              if (sensitiveTrendChart!=null)
                sensitiveTrendChart.resize();
              if (sensitiveDistributionChart!=null)
                sensitiveDistributionChart.resize();
            }
        },
        activated() {
          this.isResize = true;
          this.resize();
        },
        destroyed () {
          window.removeEventListener('resize',() => {
            this.isResize = false;
          })
        },
        watch: {
            '$store.state.brpaModule.theme': {
                handler: function (val) {
                    if(sensitivePercentChart){
                        this.sensitivePercentHandler();
                    }
                    if(sensitiveDistributionChart){
                        this.sensitiveDistributionHandler();
                    }
                    this.echartTheme();
                }
            },
            condition: function(newval){
                this.queryParams = newval;
                if (this.queryParams.id){
                    this.hsearch();
                }else{
                    this.search();
                }
            },
          exportSuccess: function(newval){
            this.resize();
          }
        },
    }
</script>

<style scoped>
</style>
